import { useState } from "react";
import { createPortal } from "react-dom";
import { IconButton } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {
  SNACK_BARS_SEVERITY_SUCCESS,
  COPIED_TO_CLIPBOARD,
} from "../../constants";
import SbuxSnackbars from "../SbuxSnackbars";
import type { MouseEvent, SyntheticEvent } from "react";
import type { SxProps, Theme } from "@mui/system";

interface Props {
  content: string;
  disabled?: boolean;
  handleClick?: ((e?: MouseEvent) => void | Promise<void>) | null;
  className?: string;
  sx?: SxProps<Theme>;
}

const SbuxContentCopy = ({
  content,
  disabled = false,
  handleClick,
  className,
  sx,
}: Props) => {
  const [open, setOpen] = useState(false);

  if (!handleClick) {
    handleClick = async () => {
      await navigator.clipboard.writeText(content);
      setOpen(true);
    };
  }

  const handleClose = (event?: Event | SyntheticEvent) => {
    event?.stopPropagation?.();
    setOpen(false);
  };

  return (
    <>
      <IconButton
        className={className}
        disabled={disabled}
        onClick={(e) => {
          e?.stopPropagation?.();
          handleClick && handleClick(e);
        }}
        sx={{
          color: "black",
          "&:focus": {
            outline: 0,
          },
          "&.MuiIconButton-root": {
            padding: "0",
            paddingLeft: "5px",
          },
          ...sx,
        }}
      >
        <ContentCopyIcon fontSize="small" />
      </IconButton>

      {/* Render via portal so the snackbar is always at viewport level,
          never clipped by table overflow or CSS stacking contexts */}
      {createPortal(
        <SbuxSnackbars
          open={open}
          message={COPIED_TO_CLIPBOARD}
          severity={SNACK_BARS_SEVERITY_SUCCESS}
          handleClose={handleClose}
        />,
        document.body,
      )}
    </>
  );
};

export default SbuxContentCopy;
